import { useState, useEffect } from 'react';
import { Grid, Button, Typography, Box, TextField } from '@mui/material';
import { getMfproductInfoByBusinessidAPI } from 'components/mfproduct/MfproductAPI';
import { useSelector } from 'react-redux';
import { createAPI } from 'components/category2product/Category2productAPI';
import { callAPI } from 'api/ApiUtils';
import { setCategory2productList, addCategory2productObj, deleteCategory2productObj } from 'store/slice/ManufSlice';
import { getCategory2productInfoByCategoryIdAPI, deleteAPI } from 'components/category2product/Category2productAPI';
import { useDispatch } from 'react-redux';
import { setCategoryProductMappingModal } from 'store/slice/ManufSlice';
import { setMessage } from 'store/slice/HeaderSlice';

export default function ProductMappingActionImpl() {
    const dispatch = useDispatch();
    const [productList, setProductList] = useState([]);
    const [filteredProductList, setFilteredProductList] = useState([]); // State for filtered product list
    const [searchTitle, setSearchTitle] = useState(''); // State for search
    const [selectedProducts, setSelectedProducts] = useState([]); // State to track selected products
    const {categoryObj} = useSelector((state) => state.manufslice.categoryDashboard);
    const Category2productResourcePrefix = "https://api.manuf.appmachine.in/category2product";
    const {category2productList} = useSelector((state) => state.manufslice);
    const {userprofileInfo} = useSelector((state)=>state.headerslice)
    
    useEffect(() => {
        getCategory2productInfoByCategoryIdAPI(categoryObj.id, loadCategory2productList, () => { }); // Call API with the selected category ID
    },[]);

    useEffect(() => {
        getMfproductInfoByBusinessidAPI(userprofileInfo.businessid, setProductList, () => { }); // Call API with a sample business ID
    }, [category2productList]);

    useEffect(() => {
        // Filter products based on search title
        const filtered = productList.filter((product) =>
            product.title.toLowerCase().includes(searchTitle.toLowerCase())
        );
        setFilteredProductList(filtered);
    }, [searchTitle, productList]);

    const loadCategory2productList = (apiResponse) => {
        dispatch(setCategory2productList(apiResponse)
        );
    }
    const getCategoryMapping = () => {
        
    };
    const linkingSuccess = (apiResponse) => {
        dispatch(addCategory2productObj(apiResponse));
    }
    
    const linkProductToCategory = (productId) => {  
        callAPI(
            Category2productResourcePrefix, "POST", {
                "categoryid":categoryObj.id,
                "productid":productId
            },linkingSuccess, ()=>{}
            //api, method, payload, successCallBack, failuerCallBack
        )
    }
    const delinkProductToCategory = (productId) => {  
        const mappingObj = category2productList.find((item) => item.productid === productId && item.categoryid === categoryObj.id);
        if (mappingObj) {
            deleteAPI(mappingObj.id, (apiResponse) => {
                dispatch(deleteCategory2productObj(apiResponse.id));
            }, () => { });
        }
        
    }

    
    return (
        <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", paddingTop:2}}>
            <Grid item lg={12} sx={{ width: '100%', backgroundColor: 'secondary.200',  }}>
                <TextField
                    label="Search by Product Title"
                    variant="outlined"
                    fullWidth
                    value={searchTitle}
                    onChange={(e) => setSearchTitle(e.target.value)}
                    sx={{ marginBottom: 2 }}
                />
                <Grid container direction="row"  sx={{ width: '100%' }}>
                    <Box lg={12} sx={{ flexGrow: 1 }}>
                        <Grid container direction="row" sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: {lg:'58vh', xs:'62vh'} }}>
                            {filteredProductList.map((product) => {
                                // Check if the product is already linked
                                const isLinked = category2productList.some((item) => item.productid === product.id);

                                return (
                                    <Grid
                                        item
                                        key={product.id}
                                        xs={6}
                                        sm={3}
                                        md={3}
                                        lg={2}
                                        sx={{ padding: 1 }}
                                        onClick={() => isLinked?delinkProductToCategory(product.id):linkProductToCategory(product.id)}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            sx={{
                                                backgroundColor: 'secondary.100',
                                                cursor: 'pointer',
                                                padding: 1,
                                                border: isLinked ? '2px solid #0050b3' : 'secondary.200', // Highlight if linked
                                                borderRadius: 2,
                                                width: '100%',
                                            }}
                                        >
                                            <Grid item>
                                                <Typography variant="h6" color="primary.dark">{product.code}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="h6" color="primary.darker">{product.title}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ width: '100%', paddingTop: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {dispatch(setCategoryProductMappingModal(false));}}
                >
                    OK
                </Button>
            </Grid>
        </Grid>
    );
}